export const convertToIsoString = (date: Date | string | null | undefined): string | undefined => {
  if (date != null) {
    const d = typeof date === 'string' ? new Date(date) : date;

    if (isNaN(d.getTime())) {
      console.warn('Invalid date:', date);
      return undefined;
    }

    const offset = d.getTimezoneOffset();
    const localDate = new Date(d.getTime() - offset * 60 * 1000);
    return localDate.toISOString().split('T')[0];
  }
  return undefined;
};
